import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const CBannerSection = ({ id }) => {
  const [slides, setSlides] = useState([]);
  const [callDone, setcallDone] = useState(false);

  const fetchData = async () => {
    try {
      const list = await corefetch(
        `Banner/GetCommonBannerDetails?displayedInID=${id}`
      );
      if (list && list.length > 0) {
        setSlides(list);
        setcallDone(true);
      } else {
        setSlides([]);
      }
    } catch (error) {
      setSlides([]);
      console.error("Error fetching list:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (slides?.length) {
      var $carousel = $(".slider-fade .owl-carousel");

      if ($carousel.hasClass("owl-loaded")) {
        $carousel.trigger("destroy.owl.carousel");
        $carousel.find(".owl-stage-outer").children().unwrap();
        $carousel.removeClass("owl-loaded");
        $carousel.removeAttr("style");
      }

      $(".owl-carousel .text-center.bg-img").each(function (e) {
        var url = $(this).data("background");
        $(this).css("background-image", `url('${url}')`);
      });

      $(".slider-fade .owl-carousel").owlCarousel({
        items: 1,
        loop: true,
        dots: false,
        margin: 0,
        autoplay: true,
        autoplayTimeout: 3000,
        animateOut: "fadeOut",
        nav: true,
        navText: [
          '<i class="ti-angle-left" aria-hidden="true"></i>',
          '<i class="ti-angle-right" aria-hidden="true"></i>',
        ],
        responsiveClass: true,
        responsive: {
          0: {
            dots: false,
          },
          600: {
            dots: false,
          },
          1000: {
            dots: false,
          },
        },
      });
    }

    return () => {
      $(".slider-fade .owl-carousel").trigger("destroy.owl.carousel");
    };
  }, [slides]);

  if ((callDone && !slides) || (callDone && slides.length === 0)) {
    var navbar = $(".navbar");
    var logo = $(".navbar .logo> img");
    navbar.addClass("shared-banner-style");
    logo.attr("src", "/assets/images/corporate-img/img/logo/meridian.png");
    if (navbar.hasClass("shared-banner-style")) {
      $(".navbar .navbar-nav .nav-link").css("color", "#000");
      $(".dropdown .nav-link i").css("color", "black");
    }
    return;
  }

  return (
    <header className="header slider-fade haveBanner">
      <div className="owl-carousel owl-theme">
        {slides?.map((banner, index) => {
          // const encodedPath = encodeURIComponent(banner.oldImagePath);
          const encodedPath = banner.oldImagePath
            .replace(/\(/g, "%28")
            .replace(/\)/g, "%29")
            .replace(/ /g, "%20");
          const fullURL = `${ImageURL}${encodedPath}`;

          return (
            <div
              key={index}
              className="text-center item bg-img"
              data-overlay-dark={4}
              data-background={fullURL}
            >
              <div className="v-middle caption">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-md-7">
                      <h1>{banner.title}</h1>
                      <p>{banner.shortDescription}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </header>
  );
};

export default CBannerSection;
